import React from 'react';
import Event from './Event';

export default class EventFireLink extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick(e) {
        e.preventDefault();
        Event.fire(this.props.eventName, this.props.data);
    }

    render() {
        return <a className={this.props.classNames} href="#" onClick={(e) => this.handleClick(e)}>{this.props.imgUrl ? <img className={this.props.imgClasses} src={this.props.imgUrl} /> : this.props.title}</a>;
    }
}
